import classNames from 'classnames';

import HeaderChessboard from './visual/HeaderChessboard';
import HeaderJob from './visual/HeaderJob';
import HeaderPerson from './visual/HeaderPerson';
import HeaderRights from './visual/HeaderRights';
import HeaderWallet from './visual/HeaderWallet';

import styles from '../../styles/animations/educepargne/header.module.css';

interface HeaderProps {
    className?: string | null;
    layout?: string | null;
}

function Header({ className = null, layout = null }: HeaderProps) {
    return (
        <div className={classNames(styles.container, className)} data-layout={layout}>
            <div className={styles.top}>
                <HeaderChessboard className={styles.chessboard} />
            </div>
            <div className={styles.bottom}>
                <div className={styles.wrapperBottom}>
                    <HeaderRights className={styles.rights} />
                    <HeaderJob className={styles.job} />
                    <HeaderPerson className={styles.person} />
                    <HeaderWallet className={styles.wallet} />
                </div>
            </div>
        </div>
    );
}

export default Header;
